// pull in config vars
import * as config from "../config"
import getJamFilledCookie from "../getJamFilledCookie"
import fetch from "isomorphic-fetch"
import getUserIdFromLocalStorage from "../getUserIdFromLocalStorage"

interface Threads {
	// TODO: What is the shape of the returned JSON?
}

export default async function getThreads(
	JAM_ID: string,
): Promise<Threads | false> {
	try {
		const res = await fetch(
			`${config.API_HOSTNAME}/api/plugin/jam/${JAM_ID}/threads`,
			{
				headers: {
					"Content-Type": "application/json",
					"jam-filled-cookie": getJamFilledCookie(),
					"jam-filled-userid": getUserIdFromLocalStorage(),
				},
			},
		)

		const json = await res.json()

		return json
	} catch (e) {
		return false
	}
}
